import { createContext } from "react";

const AppChoicesContext = createContext();
export default AppChoicesContext;
